import { Calculator, BookOpen, Languages, Globe, FlaskConical, GraduationCap, Trees, HeartPulse } from "lucide-react";

export const SUBJECT_ICONS = {
  Maths: Calculator,
  English: BookOpen,
  French: Languages,
  "History & Geography": Globe,
  Science: FlaskConical,
  SSEE: Trees,
  "Health & Physical Education": HeartPulse,
};

export const BILINGUAL_SUBJECTS = ["Maths", "Science", "History & Geography", "SSEE", "Health & Physical Education"];
const CORE = ["Maths", "English", "French", "History & Geography", "Science"];
const YOUNG = { 1: ["Maths", "English", "French", "Health & Physical Education"], 2: ["Maths", "English", "French", "Health & Physical Education"], 3: ["Maths", "English", "French", "SSEE", "Health & Physical Education"] };
export const gradeSubjects = (g) => YOUNG[Number(g)] || CORE;
export const isYoung = (g) => Number(g) >= 1 && Number(g) <= 3;
// picture questions label their choices A, B, C: show "Picture A" so the badge and the text don't repeat
export const optionLabel = (opt, hasImage, lang) => (hasImage && /^[A-D]$/.test(String(opt).trim()) ? `${lang === "fr" ? "Image" : "Picture"} ${opt}` : opt);

export function subjectIcon(name) {
  return SUBJECT_ICONS[name] || GraduationCap;
}

const SUBJECT_FR = { Science: "Sciences", "History & Geography": "Histoire-Géo", "Health & Physical Education": "Santé & EPS" };
const LEVEL_FR = { Easy: "Facile", Medium: "Moyen", Difficult: "Difficile" };
export const uiLang = () => (localStorage.getItem("aa_voice_lang") === "fr" ? "fr" : "en");
export const subjectLabel = (name, lang = uiLang()) => (lang === "fr" && SUBJECT_FR[name]) || name;
export const levelLabel = (name, lang = uiLang()) => (lang === "fr" && LEVEL_FR[name]) || name;
// Parent report: in French every subject gets its French name.
export const reportSubject = (name, lang) => (lang === "fr" ? ({ English: "Anglais", French: "Français" }[name] || subjectLabel(name, "fr")) : name);

// All five subjects are live for Grades 4, 5 and 6.
export const AVAILABLE_SUBJECTS = ["Maths", "English", "French", "History & Geography", "Science"];
export const AVAILABLE_GRADES = [4, 5, 6];
export const LIVE_GRADE = 6;

export function isAvailable(grade, subjectName, subject = null) {
  if (subject?.visible) return true;
  return AVAILABLE_SUBJECTS.includes(subjectName) && AVAILABLE_GRADES.includes(Number(grade));
}

// Subjects a child should even see on their home during the pilot.
export function visibleSubjects(subjects, grade) {
  const offered = gradeSubjects(grade);
  return (subjects || []).filter((s) => offered.includes(s.name) && (AVAILABLE_SUBJECTS.includes(s.name) || s.visible));
}
